import React, { useContext, useState, useEffect } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

import { InputLabel } from "@material-ui/core";
import { authService } from "api/axios";

// @material-ui/
import Email from "@material-ui/icons/Email";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import { AuthContext, APP_CLIENT_ID, APP_CLIENT_SECRET } from "context/AuthContext";
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(styles);
const LOGIN_URL = '/api/Login';
const GET_CLIENT_TOKEN_URL = '/api/getClientToken?client_id=';


export default function LoginPage() {
    const authContext = useContext(AuthContext);

    const history = useHistory();
    const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");

    React.useEffect(() => {
        let id = setTimeout(function () {
            setCardAnimation("");
        }, 700);
        // Specify how to clean up after this effect:
        return function cleanup() {
            window.clearTimeout(id);
        };
    });
    const classes = useStyles();


    const [user_name, setUserName] = useState('');
    const [pwd, setPwd] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const [clientToken, setClientToken] = useState('');

    //const userRef = useRef();
    //const errRef = useRef();

    let clientId = "8";
    //useEffect(() => {
    //'    userRef.current.focus();
    //}, [])

    useEffect(() => {
    }, []);

    useEffect(() => {
        setErrMsg('');
    }, [user_name, pwd]);

    useEffect(() => {
        // here we need to get the client credential token
        let isMounted = true;
        const controller = new AbortController();

        const getClientToken = async () => {
            try {
                var credentials = btoa(APP_CLIENT_ID + ':' + APP_CLIENT_SECRET);
                var basicAuth = 'Basic ' + credentials;
                const response = await authService.get(GET_CLIENT_TOKEN_URL + clientId.toString(), { headers: { 'Authorization': basicAuth } })

                isMounted && setClientToken(response.data.token);
            } catch (err) {
                console.error(err);
            }
        }

        getClientToken();

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [])


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await authService.post(LOGIN_URL,

                JSON.stringify({ client_id: clientId, user_name: user_name, password: pwd }),
                {
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${clientToken}` },
                    withCredentials: true,

                }
            );
            const accessToken = response?.data?.message?.token;
            const first_name = response?.data?.message?.first_name;
            const last_name = response?.data?.message?.last_name;

            const roles = [2001, 5150];
            authContext.login(JSON.stringify({ "user_name": user_name, "first_name": first_name, "last_name": last_name, "roles": roles, "token": accessToken }));
            history.push("/admin/dashboard");
        }
        catch (err) {
            console.log(err);
            if (!err?.response) {
                if (JSON.stringify(err) != '{}') {
                    setErrMsg('No Server Response');
                }
                else {
                    history.push("/admin/dashboard");
                }
            } else if (err.response?.status === 400) {
                setErrMsg('Missing Username or Password');
            } else if (err.response?.status === 401) {
                setErrMsg('Unauthorized');
            } else {
                setErrMsg('Login Failed');
            }
            //    errRef.current.focus();
        }
    }

    const handleForgotPassword = () => {
        history.push("/auth/forgot-password");
        console.log("Forgot Passwrod");
    };

    return (
        <div className={classes.container}>
            <GridContainer justify="center">
                <GridItem xs={12} sm={6} md={4}>
                    <form>
                        <Card login className={classes[cardAnimaton]}>
                            <CardHeader
                                className={`${classes.cardHeader} ${classes.textCenter}`}
                                color="success"
                            >
                                <h3 className={classes.cardTitle}>Log in</h3>
                                <div className={classes.socialLine}>
                                    <h4>Please Login in to get access to the Portal</h4>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <InputLabel fontWeight="medium" color="text"> {errMsg} </InputLabel>
                                <CustomInput
                                    labelText="Email..."
                                    id="email"
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                    inputProps={{
                                        onChange: (event) => {
                                            setUserName(event.target.value);
                                        },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Email className={classes.inputAdornmentIcon} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <CustomInput
                                    labelText="Password"
                                    id="password"
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                    inputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Icon className={classes.inputAdornmentIcon}>
                                                    lock_outline
                                                </Icon>
                                            </InputAdornment>
                                        ),
                                        onChange: (event) => {
                                            setPwd(event.target.value);
                                        },
                                        type: "password",
                                        autoComplete: "off",
                                    }}
                                />
                            </CardBody>
                            <CardFooter className={classes.justifyContentCenter}>
                                <Button color="primary" simple size="lg" block onClick={handleForgotPassword}>
                                    Forgot Password
                                </Button>
                                <Button color="success" simple size="lg" block onClick={handleSubmit}>
                                    Login Now
                                </Button>
                            </CardFooter>
                        </Card>
                    </form>
                </GridItem>
            </GridContainer>
        </div>
    );
}
